
import { Modal } from 'antd';
import { AppState } from 'interface/stateApp';
import CollaboratorsList from './ColaboratorList';

interface FormProps {
    stateApp: AppState;
    setStateApp: React.Dispatch<React.SetStateAction<AppState>>;
    ticket?: any,
    onData?: any,
}

export default function ColaboratorListModal({ stateApp, setStateApp,ticket,onData}: FormProps) {
    const { showColaboratorListForm } = stateApp;
    return (
        <Modal
            open={showColaboratorListForm}
            onCancel={() => setStateApp({
              ...stateApp,
              showColaboratorListForm: false,
            })}
            footer={[]}
            className="mx-auto w-full md:!w-[550px] rounded-full"
        >
            <div className='p-[2px]'>
                <CollaboratorsList stateApp={stateApp} setStateApp={setStateApp} ticket={ticket} onData={onData}></CollaboratorsList>
            </div>

        </Modal>
    );
}
